
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { User, Phone } from 'lucide-react';
import { TranscriptMessage } from '@/hooks/useTwilioTranscription';

interface TranscriptEntryProps {
  message: TranscriptMessage;
}

export const TranscriptEntry = ({ message }: TranscriptEntryProps) => {
  const isCaller = message.speaker === 'caller';
  const time = message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  
  return (
    <div className={`flex gap-2 mb-1 ${isCaller ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-[85%] ${isCaller ? 'order-2' : 'order-1'}`}>
        <div className={`px-1 py-0.5 text-sm ${
          isCaller 
            ? 'text-primary ml-auto' 
            : 'text-foreground'
        }`}>
          <div className="break-words">{message.text}</div>
          <div className={`flex items-center gap-1 text-xs opacity-70 mt-1 ${isCaller ? 'justify-end' : 'justify-start'}`}>
            {isCaller ? <User className="h-2.5 w-2.5" /> : <Phone className="h-2.5 w-2.5" />}
            <span className="text-xs">
              {isCaller ? 'You' : 'Receiver'} • {time}
            </span>
            {message.confidence && (
              <Badge 
                variant="outline" 
                className="text-[10px] px-1 py-0 h-4 border-current/20 bg-current/10"
                title={`Confidence: ${Math.round(message.confidence * 100)}%`}
              >
                {Math.round(message.confidence * 100)}%
              </Badge>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
